import PropTypes from 'prop-types'
import React from 'react'
import { Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap'
import expand from '../../assets/images/expand_more_sm.svg'
import { NAV_MODULE_ICON } from '../../constants'
import SearchInput from '../../containers/ESSearch/SearchInput'
import { getAbsoluteLink, getVersionIcon } from '../../helpers/utils'
import '../../types'
import Category from './components/Category'
import Link from './components/Link'
import Shop from './components/Shop'
import { FlexDirection, LinksV4, NavigationV4, TabV4 } from './styled'

const Title = ({ title, noCaret = false }) => {
  return (
    <TabV4>
      <div className="animated slideInLeft text-title">{title}</div>
      <div className="animated fadeIn" style={{ animationDelay: '0.8s' }}>
        {!noCaret && <img src={expand} alt="expand" className="blue" />}
      </div>
    </TabV4>
  )
}

/**
 * @typedef {Object} NavbarV4Props
 * @property {Header} header
 * @property {function(): void} toggleDeviceModal
 * @property {string} version
 * @property {TopLinks} topLinks
 */

/**
 * NavbarV4
 * The main navigation component tree for within HeaderV3
 * @param {NavbarV4Props}
 * @returns {React.ElementType}
 */
const NavbarV4 = ({ header, toggleSearchModal, version, topLinks }) => {
  if (!Object.keys(header).includes('items')) return null
  const menuItems = header.items.navigation.item
  const { cartIconUrl } = header.items.navigation

  return (
    <NavigationV4
      className="animated slideInDown navbar-shrink"
      id="nav-container"
    >
      <a
        id="brand"
        href={getAbsoluteLink('/', version)}
        className="hidden-xs hidden-sm"
      >
        <img
          src={getAbsoluteLink('content/dam/tbvz/logos/desktop_lg.png', version)}
          alt="Logo Homepage"
        />
      </a>
      <Navbar className="upper-navbar hidden-sm hidden-xs" id="navbar">
        <NavItem eventKey={1} href={topLinks.url}>
          {
            header.items.languagenavigation.items.find(
              language => !language.active
            ).title
          }
        </NavItem>
        <NavItem eventKey={2} href="#">
          <img
            src={getVersionIcon(NAV_MODULE_ICON.location)}
            alt="location"
            height="24px"
            className="black"
          />
          <span className="small-text">
            {header.items.locationservices.locationlabel}
          </span>
        </NavItem>
        {header.links.map((link, i) => {
          return (
            <NavItem
              className="text border flex-hidden"
              href={getAbsoluteLink(link.linkUrl, version)}
              alt={link.linkAltText}
              key={`${i}_${link.linkText}`}
            >
              {link.linkText}
            </NavItem>
          )
        })}
      </Navbar>
      <Navbar className="lower-navbar">
        <Navbar.Header>
          <Navbar.Toggle />
          <a id="brand" href={getAbsoluteLink('/', version)} className="hidden-lg hidden-md">
            <img
              src={getAbsoluteLink('content/dam/tbvz/logos/desktop_lg.png', version)}
              alt="Logo Homepage"
            />
          </a>
          <Nav className="hidden-lg hidden-md icons-container-sm">
            <NavItem
              className="icon"
              href={getAbsoluteLink('login', version)}
              style={{ padding: '10px' }}
            >
              <span>
                <img
                  src={getVersionIcon(NAV_MODULE_ICON.person)}
                  alt="account"
                  className="black"
                />
              </span>
            </NavItem>
            <NavItem
              className="icon"
              href={getAbsoluteLink(cartIconUrl)}
              style={{ padding: '10px 10px 10px 0px' }}
            >
              <span>
                <img
                  src={getVersionIcon(NAV_MODULE_ICON.shopping)}
                  alt="shopping cart"
                  className="black"
                />
              </span>
            </NavItem>
          </Nav>
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <div className="hidden-md hidden-lg search">
              <SearchInput
                toggleSearchModal={toggleSearchModal}
                aria-label="Search Mobile"
              />
            </div>
            {menuItems.map((item, i) => {
              const mItems = item.children
              const containsShop = item.title === 'Shop'
              const containsRefill = item.title === 'Refill'
              if(Array.isArray(mItems) && mItems.length > 0) {
                return (
                    <NavDropdown
                    className={`${containsShop ? 'full' : ''}`}
                    key={`${i}_${item.title}`}
                    eventKey={3}
                    title={
                        <div className="nav-title">
                        <Title title={item.title} noCaret />
                        <div className="expand-more">
                            <img
                            src={require('../../assets/images/expand_more_sm.svg')}
                            alt="expand_more"
                            className="black"
                            />
                        </div>
                        <div className="chevron-container">
                            <div className="chevron" />
                        </div>
                        </div>
                    }
                    noCaret
                    >
                    <FlexDirection className={containsShop ? 'column' : ''}>
                        {containsShop && (
                        <div className="menu">
                            <div
                            style={{ width: '100%' }}
                            className="hidden-lg hidden-md border"
                            >
                            {item.quickLinks.length > 0 && (
                                <Shop
                                data={item.quickLinks}
                                title={item.quickLinksHeading}
                                version={version}
                                />
                            )}
                            </div>
                            <p
                            className={`hidden-md hidden-lg hidden-xl ${
                                containsShop ? 'hidden' : 'category-name'
                            }`}
                            >
                            {item.title}
                            </p>
                            {mItems.map((it, i) => {
                            return (
                                <li
                                key={`${i}_${it.title}`}
                                className={
                                    containsShop ? 'shop-category' : 'category'
                                }
                                >
                                <Category
                                    data={it}
                                    list={it.children}
                                    containsShop={containsShop}
                                    version={version}
                                />
                                </li>
                            )
                            })}
                            <li
                            style={{
                                border: '1px solid #d8dada'
                            }}
                            />

                            <li>
                            {item.quickLinks.length > 0 && (
                                <Shop
                                data={item.quickLinks}
                                title={item.quickLinksHeading}
                                className="hidden-xs hidden-sm"
                                version={version}
                                shopStyle="custom-links"
                                />
                            )}
                            </li>
                        </div>
                        )}
                        {containsRefill && (
                        <div>
                            {mItems.map((it, i) => {
                            return (
                                <li
                                key={`${i}_${it.title}`}
                                className={
                                    containsShop ? 'shop-category' : 'category'
                                }
                                >
                                <Category
                                    data={it}
                                    list={it.children}
                                    containsShop={containsShop}
                                    version={version}
                                />
                                </li>
                            )
                            })}
                        </div>
                        )}
                        {!containsShop && !containsRefill && (
                        <div>
                            <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderBottom: '1px solid var(--grey-7)'
                            }}
                            >
                            <div
                                style={{
                                minWidth: '150px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                                }}
                            >
                                <p className="title">{item.flyoutHeader}</p>
                                {item.flyoutButtonLabel && (
                                <Link href={getAbsoluteLink(item.flyoutButtonLink, version)} version={version}>
                                    Learn more
                                </Link>
                                )}
                            </div>
                            </div>

                            {mItems.map((it, i) => {
                            return (
                                <li key={`${i}_${it.title}`}>
                                <Category
                                    data={it}
                                    list={it.children}
                                    containsShop={containsShop}
                                    version={version}
                                />
                                </li>
                            )
                            })}
                        </div>
                        )}
                    </FlexDirection>
                    </NavDropdown>
                )
              }
              return (
                <NavItem
                  className="dropdown menu-item animated slideInLeft"
                  href={getAbsoluteLink(item.url, version)}
                  key={`${item}_${i}`}
                >
                  <Title title={item.title} noCaret />
                </NavItem>
              )
            })}
            <LinksV4>
              {header.items.navigation.navigationLinks.map((item, i) => {
                return (
                  <NavItem
                    key={`${i}_${item.linkText}`}
                    href={getAbsoluteLink(item.linkUrl, version)}
                    rel="noopener noreferrer"
                    className="text-link"
                  >
                    {item.linkText}
                  </NavItem>
                )
              })}
              <NavItem
                className="icon hidden-xs hidden-sm"
                onClick={() => toggleSearchModal()}
              >
                <span>
                  <img
                    src={getVersionIcon(NAV_MODULE_ICON.search)}
                    alt="search"
                    className="black"
                  />
                </span>
              </NavItem>
              <NavItem className="icon hidden-xs hidden-sm" href={getAbsoluteLink(cartIconUrl, version)}>
                <span>
                  <img
                    src={getVersionIcon(NAV_MODULE_ICON.shopping)}
                    alt="shopping cart"
                    className="black"
                  />
                </span>
              </NavItem>
            </LinksV4>
          </Nav>
          <div className="hidden-lg hidden-md switches">
            <Nav>
              <NavItem eventKey={1} href={topLinks.url}>
                <span className="small-text">
                  {
                    header.items.languagenavigation.items.find(
                      language => !language.active
                    ).title
                  }
                </span>
              </NavItem>
              <NavItem eventKey={2} href="#">
                <img
                  src={getVersionIcon(NAV_MODULE_ICON.location)}
                  alt="location"
                  height="24px"
                  className="black"
                />
                <span className="small-text">Enter your ZIP</span>
              </NavItem>
              {header.links.map(( link, i) => {
                return (
                  <NavItem
                    key={`${i}_${link.linkText}`}
                    className="animated slideInLeft"
                    href={getAbsoluteLink(link.linkUrl, version)}
                    alt={link.linkAltText}
                  >
                    <span className="small-text">{link.linkText}</span>
                  </NavItem>
                )
              })}
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </NavigationV4>
  )
}

NavbarV4.propTypes = {
  version: PropTypes.string.isRequired,
  header: PropTypes.object.isRequired,
  toggleSearchModal: PropTypes.func,
  topLinks: PropTypes.shape({
    url: PropTypes.string.isRequired,
    show: PropTypes.bool,
    text: PropTypes.string
  }).isRequired
}

export default NavbarV4



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarV4.js